var _excluded = ["heading", "logo", "skeleton", "subHeading", "title"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/core/Skeleton';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Heading from '../Heading';
import Text from '../Text';
import { hexToRgba } from '../../utils/colors';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      background: '#fff',
      borderBottom: "1px solid " + hexToRgba(theme.palette.default.main, 0.4)
    }
  };
});
var StyledImgWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    overflow: hidden;\n    margin-left: 0.5em;\n    flex-basis: 150px;\n    justify-content: flex-end;\n    align-items: center;\n    height: 80px;\n\n    @media screen and (min-width: ", "px) {\n      margin-left: 1em;\n      flex-basis: 250px;\n    }\n\n    @media screen and (min-width: ", "px) {\n      margin-left: 1em;\n      flex-basis: 250px;\n    }\n  "])), theme.breakpoints.sm, theme.breakpoints.values.sm);
});
var StyledImg = styled.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  max-height: 100%;\n"])));
var StyledImgText = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n    background: ", ";\n    color: ", ";\n    font-size: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  "])), theme.palette.grey[400], theme.palette.background.paper, theme.typography.size.scale(9));
});
var Nameplate = function Nameplate(_ref3) {
  var heading = _ref3.heading,
    logo = _ref3.logo,
    skeleton = _ref3.skeleton,
    subHeading = _ref3.subHeading,
    title = _ref3.title,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded);
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('sm');
  });
  var classes = useStyles({
    isMobile: isMobile
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Container, _extends({
    maxWidth: "md"
  }, rest), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
      alignItems: 'center',
      px: isMobile ? 2 : 0,
      py: 4
    }
  }, skeleton ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    width: isMobile ? '80%' : '40%',
    height: isMobile ? 22 : 30
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: isMobile ? '60%' : '30%',
    height: isMobile ? 22 : 30
  })), /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rect",
    height: 100,
    width: 100
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    variant: "body1",
    weight: "600"
  }, isMobile && /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("small", null, title)), !isMobile && title), /*#__PURE__*/React.createElement(Heading, {
    as: isMobile ? 'h5' : 'h3',
    weight: "400",
    color: "textPrimary",
    gutterBottom: false
  }, heading, subHeading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), " ", subHeading))), /*#__PURE__*/React.createElement(StyledImgWrapper, null, logo && /*#__PURE__*/React.createElement(StyledImg, {
    src: logo,
    alt: heading
  }), !logo && heading && /*#__PURE__*/React.createElement(StyledImgText, null, heading[0].toUpperCase()))))));
};
Nameplate.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Heading
   */
  heading: PropTypes.string,
  /**
   * Sub Heading
   */
  subHeading: PropTypes.string,
  /**
   * Show skeleton layout
   */
  skeleton: PropTypes.bool,
  /**
   * URL for the property manager logo
   */
  logo: PropTypes.string,
  /**
   * Text displayed before heading
   */
  title: PropTypes.string
} : {};
Nameplate.defaultProps = {
  heading: '',
  subHeading: '',
  skeleton: false,
  logo: '',
  title: ''
};
export default Nameplate;